var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c(Component,{key:_vm.$route.fullPath,tag:"component"})],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }